<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page04">
</a><a id="page05">
<p class="dedicationText"><em class="italic">To my tiny grandson:<br/> Reginn Freyr Mánason</em></p>
</a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mysoultotake_ded01.vue?02aae04a